/* eslint-disable no-unused-vars */
import axios from '@axios'
import organization from '@/store/account/organization/moduleOrganization'

export default {

  getOrganizationLocalizations({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/organizations/${organization.state.activeOrganizationId}/localizations`, state.filters)
        .then(response => {
          commit('SET_PAGINATION', response.data.result)
          commit('SET_LOCALIZATIONS', response.data.result.items)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  deleteLocalization({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/organizations/${organization.state.activeOrganizationId}/localizations/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  addCustomLocalization({ state }, { name, languageId, playerType }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/organizations/${organization.state.activeOrganizationId}/localizations?name=${name}&languageId=${languageId}&playerType=${playerType}`,
        method: 'POST',
      })
        .then(async response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  setDefaultOrganization({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/organizations/${organization.state.activeOrganizationId}/localizations/${id}/set-default`)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  getLocalizationById({ commit, state }, { id, status }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/organizations/${organization.state.activeOrganizationId}/localizations/${id}?getAllLocalizations=${status}`)
        .then(response => {
          commit('SET_LOCALIZATION', response.data.result)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  getLocalizationSelectList({ commit, state }, playerType) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organizations/${organization.state.activeOrganizationId}/localizations/select-list`, {
          params: { playerType },
        })
        .then(response => {
          commit('SET_LOCALIZATION_OPTIONS', response.data.result)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  playersLocalizations({ commit, state }, { playerType }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organizations/${organization.state.activeOrganizationId}/localizations/players?playerType=${playerType}`)
        .then(response => {
          commit('SET_PLAYERS_LOCALIZATIONS', response.data.result)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateLocalizationById({ commit, state }, { id, data }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/organizations/${organization.state.activeOrganizationId}/localizations/${id}`, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  duplicateLocalization({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/organizations/${organization.state.activeOrganizationId}/localizations/duplicate`, data)
        .then(async response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
}
